import React, { useEffect, useState } from 'react'
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';
import Modal from 'react-modal';
import { FaEye } from "react-icons/fa";
import axios from "axios"
const MyPost = () => {
    const [mypostJson, setMypostjson] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [editIndex, setEditIndex] = useState(null);
    // Calculate the displayed items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = mypostJson.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handleDelete = async (index) => {
   
    const actualIndex = (currentPage - 1) * itemsPerPage + index;
    const jobToDelete = mypostJson[actualIndex];

    
    const isConfirmed = window.confirm(`Are you sure you want to delete the post for "${jobToDelete.jobtitle}"?`);

    // 3. Only proceed if the user clicked "OK"
    if (isConfirmed) {
        try {
            // Call the backend
            await axios.delete(`https://api-zspzr757qa-uc.a.run.app/deletejob/${jobToDelete.id}`);
            const updateTable = mypostJson.filter((_, ind) => actualIndex !== ind);
            setMypostjson(updateTable);
            
            console.log("Delete successful");
        } catch (error) {
            console.error("Delete failed:", error);
            alert("Could not delete the post. Please try again.");
        }
    } else {
      
        console.log("Delete canceled by user");
    }
};
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenView, setIsModalOpenview] = useState(false);
    const [alignToCenter, setAlignToCenter] = useState(true);
    const toggleAlignment = () => {
        setAlignToCenter((prevAlignToCenter) => !prevAlignToCenter);
    };
    const openModal = () => {
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const modalStyle = {
        content: {
            position: 'absolute',
            top: alignToCenter ? '50%' : 'auto',
            right: alignToCenter ? '50%' : 0,
            bottom: alignToCenter ? '50%' : 0,
            left: alignToCenter ? '50%' : 'auto',
            transform: alignToCenter ? 'translate(-50%, -50%)' : 'translate(0, 0)',
            margin: 0,
            height: alignToCenter ? '80%' : '80%',
            width: alignToCenter ? '40%' : '30%', // Adjusted width when centered
            borderRadius: '10px',
        },
    };
    const [formData, setFormData] = useState({
        dateofpost: '',
        jobtitle: '',
        positionlevel: '',
        experience: '',
        jobtype: '',
        prefereddateofjoin: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // Only include the fields from your current form
        const payload = {
            JobTitle: formData.jobtitle,
            PositionLevel: formData.positionlevel,
            Experience: formData.experience,
            JobType: formData.jobtype,
            JoinDate: formData.prefereddateofjoin
        };

        try {
            if (editIndex !== null) {
                const jobToUpdate = mypostJson[editIndex];

                await axios.put(`https://api-zspzr757qa-uc.a.run.app/updatejob/${jobToUpdate.id}`, payload);

                // Create the updated object matching your table's expected keys
                const updatedPost = {
                    ...formData,
                    id: jobToUpdate.id,
                    PositionLevel: formData.positionlevel, // Sync keys
                    Experience: formData.experience,
                    JobType: formData.jobtype
                };

                const updatedPosts = mypostJson.map((post, index) =>
                    index === editIndex ? updatedPost : post
                );
                setMypostjson(updatedPosts);
            } else {
                // --- ADD MODE ---
                // Note: If adding a NEW job, you MUST provide Location/Description 
                // because your Schema says they are 'required: true'
                const newJobPayload = {
                    ...payload,
                    Location: "Not Specified",
                    JobDescription: "Default Description",
                    Tools: "None"
                };
                const response = await axios.post("https://api-zspzr757qa-uc.a.run.app/addjob", newJobPayload);
                setMypostjson([...mypostJson, { ...formData, id: response.data._id }]);
            }

            setIsModalOpen(false);
            setEditIndex(null);
            setFormData({
                dateofpost: '',
                jobtitle: '',
                positionlevel: '',
                experience: '',
                jobtype: '',
                prefereddateofjoin: ''
            });

        } catch (error) {
            console.error("Update failed:", error);
            alert("Check console - you might be missing required fields for NEW posts.");
        }
    };
    const handleEdit = (index) => {
        // Calculate global index: (Page 1 * 5) + 0 = 5 (First item of page 2)
        const actualIndex = (currentPage - 1) * itemsPerPage + index;
        setEditIndex(actualIndex);

        const selectedPost = mypostJson[actualIndex];

        // Map the capitalized keys back to your lowercase formData keys
        setFormData({
            dateofpost: selectedPost.dateofpost,
            jobtitle: selectedPost.jobtitle,
            positionlevel: selectedPost.PositionLevel,
            experience: selectedPost.Experience,
            jobtype: selectedPost.JobType,
            prefereddateofjoin: selectedPost.prefereddateofjoin
        });
        setIsModalOpen(true);
    };
    const [viewData, setViewData] = useState(null);
    const handleViewopenmodal = (index) => {
        const actualIndex = indexOfFirstItem + index;
        setViewData(mypostJson[actualIndex]);
        setIsModalOpenview(true);
    };
    const closeModalview = () => {
        setIsModalOpenview(false);
    };



    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const res = await axios.get("https://api-zspzr757qa-uc.a.run.app/jobs");


                const formattedData = res.data.map(job => ({
                    dateofpost: new Date(job.createdAt).toISOString().split('T')[0],
                    id: job._id,
                    jobtitle: job.JobTitle,
                    PositionLevel: job.PositionLevel,
                    Experience: job.Experience,
                    JobType: job.JobType,
                    prefereddateofjoin: job.JoinDate
                }));

                setMypostjson(formattedData);
            } catch (error) {
                console.log("Error fetching jobs:", error);
            }
        };

        fetchJobs();
    }, []);

    return (
        <div>
            <h3 className="text-center text-dark fw-bold mt-5">View Post</h3>
            <table className='myjobtable'>
                <thead>
                    <tr>
                        <td>Job Title</td>
                        <td>Position Level</td>
                        <td>Job Type</td>
                        <td>Experience Required</td>
                        <td>Prefered Date Of Joining</td>
                        <td>Date Of Post</td>
                        <td>Action</td>
                    </tr>
                </thead>

                <tbody>
                    {currentItems.map((job, index) => (
                        <tr key={index}>
                            <td>{job.jobtitle}</td>
                            <td>{job.PositionLevel}</td>
                            <td>{job.JobType}</td>
                            <td>{job.Experience}</td>
                            <td>{job.prefereddateofjoin}</td>
                            <td>{job.dateofpost}</td>
                            <td className='d-flex'>
                                <FaEye
                                    style={{ cursor: 'pointer', marginRight: '10px' }}
                                    onClick={() => handleViewopenmodal(index)}
                                />
                                <FaEdit
                                    style={{ cursor: 'pointer', marginRight: '10px' }}
                                    onClick={() => handleEdit(index)}
                                />
                                <FaTrash
                                    style={{ cursor: 'pointer', marginRight: '10px' }}
                                    onClick={() => handleDelete((currentPage - 1) * itemsPerPage + index)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Pagination
                itemsPerPage={itemsPerPage}
                totalItems={mypostJson.length}
                paginate={paginate}
                currentPage={currentPage}
            />
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Add Post Modal"
                id='modal-res'
                overlayClassName="Overlay zindexpp fade-in zindexpp"
                style={modalStyle}
            >
                <>
                    <a onClick={closeModal} className="d-flex justify-content-end mt-1" style={{ marginTop: '-20px' }}>
                        <div className="cross" style={{ height: '20px', width: '20px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg>
                        </div>
                    </a>
                    <h3 className="text-center bg-theme text-white mt-2 pt-1 pb-1">Edit Post</h3>
                    <form onSubmit={handleFormSubmit}>
                        <label>Date Of Post:</label>
                        <input type="text" className='form-control' name="dateofpost" value={formData.dateofpost} onChange={handleInputChange} />

                        <label>Job Title:</label>
                        <input type="text" className='form-control' name="jobtitle" value={formData.jobtitle} onChange={handleInputChange} />

                        <label>Position Level:</label>
                        <input type="text" className='form-control' name="positionlevel" value={formData.positionlevel} onChange={handleInputChange} />

                        <label>Experience:</label>
                        <input type="text" className='form-control' name="experience" value={formData.experience} onChange={handleInputChange} />

                        <label>Job Type:</label>
                        <input type="text" className='form-control' name="jobtype" value={formData.jobtype} onChange={handleInputChange} />

                        <label>Preferred Date Of Joining:</label>
                        <input type="text" className='form-control' name="prefereddateofjoin" value={formData.prefereddateofjoin} onChange={handleInputChange} />

                        <button type="submit" className='btn btn-primary mt-2'>Submit</button>
                    </form>
                </>
            </Modal>
            {/* view Modal */}
            <Modal
                isOpen={isModalOpenView}
                onRequestClose={closeModalview}
                contentLabel="View Post Modal"
                id='modal-res-view'
                overlayClassName="Overlay zindexpp fade-in zindexpp"
                style={modalStyle}
            >
                <>
                    <a onClick={closeModalview} className="d-flex justify-content-end mt-1" style={{ marginTop: '-20px' }}>
                        <div className="cross" style={{ height: '20px', width: '20px' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg>
                        </div>
                    </a>
                    <h3 className="text-center bg-theme text-white mt-2 pt-1 pb-1">Post Details</h3>
                    {/* Display all properties of viewData */}
                    {viewData && (
                        <div className='mt-4'>
                            {/* <h3 className="text-center bg-theme text-white mt-2 pt-1 pb-1">View Post</h3>
                            {Object.keys(viewData).map((key, index) => (
                                <p key={index}>
                                    {key.replace(/([A-Z])/g, ' $1').trim()}: {viewData[key]}
                                </p>
                            ))} */}
                            <p className="field">Date Of Post: <span>{viewData.dateofpost}</span></p>
                            <p className="field">Job Title: <span>{viewData.jobtitle}</span></p>
                            <p className="field">Position Level: <span>{viewData.PositionLevel}</span></p>
                            <p className="field">Experience: <span>{viewData.Experience}</span></p>
                            <p className="field">Job Type: <span>{viewData.JobType}</span></p>
                            <p className="field">Preferred Date Of Joining: <span>{viewData.prefereddateofjoin}</span></p>
                        </div>
                    )}
                </>
            </Modal>

        </div>
    )
}
const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <div className='d-flex justify-content-center'>
            <ul className='pagination '>
                {pageNumbers.map(number => (
                    <li key={number} className={`page-item ${number === currentPage ? 'active' : ''}`}>
                        <button onClick={() => paginate(number)} className='page-link '>
                            {number}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};
export default MyPost